import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import AvatarEditor from 'flarum/forum/components/AvatarEditor';

app.initializers.add('monsternone/flarum-ext-avatar-uploader-replace', () => {
  override(AvatarEditor.prototype, 'openPicker', function () {
    if (this.loading) return;

    // Create a hidden HTML input element and click on it so the user can select
    // an avatar file. Once they have, we will upload it via the API.
    const $input = $('<input type="file" accept="image/*">');

    $input
      .appendTo('body')
      .hide()
      .click()
      .on('input', (e) => {
        this.upload($(e.target)[0].files[0]);
      });
  });
});

